import React, { useState } from 'react'
import { trans } from 'sharedKernel/i18n'
import { useParams, useLocation } from 'react-router-dom'
import { IdeaApplicationForm } from 'domain/feature/hub/evaluator/idea/evaluate/IdeaApplicationForm'
import { GetFormat, useGet } from 'sharedKernel/api'
import { NoContent } from 'components/NoContent'
import { Loading } from 'components/loading'
import styled from 'styled-components'
import { MobileContainerPadding } from './index.style'

const PageWrapper = styled.div`
  min-height: 100vh;
  width: 100%;
`

export const HubEvaluatorIdeaEvaluatePage = ({ ...props }): JSX.Element => {
  const [isNavigationBlocked, setIsNavigationBlocked] = useState<boolean>(false)
  const { challengeId, stepId, ideaId } = useParams()
  const location = useLocation()
  const stepName = (location.state as any)?.stepName || ''

  const request: GetFormat = {
    url: `/v1/hub/evaluator/challenge/${challengeId}/step/${stepId}/solution/${ideaId}`
  }
  const { data, isFetching } = useGet(request, request.url)

  const labels = {
    noContent: trans('Houve um erro ao recuperar o evento.')
  }

  const renderResponse = (): any => {
    if (isFetching) {
      return <Loading />
    } else if (data == null) {
      return <NoContent text={labels.noContent} />
    } else {
      return <IdeaApplicationForm setIsNavigationBlocked={setIsNavigationBlocked} ideaApplicationData={data.data} stepName={stepName} />
    }
  }
  return (
    <PageWrapper>
      <MobileContainerPadding />
      {renderResponse()}
    </PageWrapper>
  )
}
